// eslint-disable-next-line
import { Component, CustomElement } from "../../core/CustomElement";
import "../dialog/dialog";
import CCCDialog from "../dialog/dialog";
import "../forms/select-single/index";
import "../forms/button/index";

@Component("ccc-jira-dialog", {
  template: require("./jiraDialog.html").default,
  style: require("./jiraDialog.scss").default,
  viewModel: require("./jiraDialogVm"),
})
// eslint-disable-next-line
export default class CCCJiraDialog extends CustomElement {
  constructor() {
    super();
  }

  public set uiUrl(value: string) {
    this.viewModel.uiUrl(value);
  }

  public open(): void {
    (this.shadowDom.querySelector(".ccc-jira-dialog") as CCCDialog).open();
  }

  public onClose(callback: () => void): void {
    (this.shadowDom.querySelector(".ccc-jira-dialog") as CCCDialog).onClose(
      callback
    );
  }
}
